import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index.jsx"
import Icons from "../../assets/icons/index.jsx"
import { useQuery } from "@apollo/client";
import { GET_ALL_Video, GET_Video_Layer } from "../../gql/queries.jsx";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getPercentage } from "../../utils/index.js";
import { NavLink, Link } from "react-router-dom";
import { firebaseData } from "../../firebase/index.jsx";
import NoDataFound from "../common/NoDataFound/NoDataFound.jsx";
import { authorizationCheck } from "../../utils/logout.jsx";
import Loader from "../common/Loader/Loader.jsx";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong.jsx";
import { decrypt } from "../../utils/crypto.jsx";
import ConnectionError from "../common/NoDataFound/ConnectionError.jsx";
function VideoLayerTopic() {
    let { id } = useParams()
    const navigate = useNavigate()
    const completePathUrl = useLocation()
    const [config, setConfig] = useState({});
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [version, setVersion] = useState(JSON.parse(localStorage.getItem('version')));
    const [language, setLanguage] = useState(JSON.parse(localStorage.getItem('language')));
    const query1 = useQuery(GET_Video_Layer, {
        variables: {
            "_id": id,
            "language": language,
            "contentType": "videos"
        },
    });
    const query2 = useQuery(GET_ALL_Video, {
        variables: {
            "courseName": course.preparingFor,
            "version": parseInt(version.actual),
            "status": true,
            "contentType": "videos",
            "isRoot": true
        },
    });

    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('video_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);

    if (query1.loading || query2.loading) return (<><Loader /></>)
    if (query1.error || query2.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED') || query2.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(navigate)
        } 
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') ||query2.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)

        }
        console.log(query1.error.graphQLErrors);
        console.log(query2.error.graphQLErrors);
    }

    let topiclist
    query1.data && query1.data.layer.subLayers.map(obj => {
        if (obj.layerType === 'topic_list') {
            topiclist = obj.subLayers
            return
        }
    })

    let contentlist
    let contentId
    query1.data && query1.data.layer.subLayers.map(obj => {
        if (obj.layerType === 'concept_list') {
            contentId = obj._id
            contentlist = obj.subLayers
            return
        }
    })

    let contentslist
    query1.data && query1.data.layer.subLayers.map(obj => {
        if (obj.layerType === 'concept_list') {
            contentslist = obj.subContents
            return
        }
    })

    let resourcelist
    query1.data && query1.data.layer.subLayers.map(obj => {
        if (obj.layerType === 'resource_list') {
            resourcelist = obj.subLayers
            return
        }
    })

    let videolist
    query2.data && query2.data.layers.map(obj => {
        if (obj.layerType === 'subject_list') {
            videolist = obj.subLayers
            return
        }
    })

    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a>Home</a></li>
                        <li className="breadcrumb-item">Video</li>
                        <li className="breadcrumb-item active">{query1.data && query1.data.layer ? query1.data.layer.title : ""}</li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper section_side_padding">
                    <div className="row">
                        <div className="col-lg-8 col-md-8 col-sm-12">
                            <div className="topics_wrapper_main">
                                {
                                    topiclist && topiclist.length != 0 &&
                                    <>
                                        <div className="subjects_wrapper topic_header">
                                            <div className="topic_header_content d-flex align-items-center">
                                                <div className="topic_image_ttl d-flex align-items-center">
                                                    <Link to={"/videolayer"}>
                                                        <figure className="back_arrow">
                                                            <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                                        </figure>
                                                    </Link>
                                                    <figure className="subject_inner_img">
                                                        <img src={query1.data.layer ? query1.data.layer.icon : Images.defaultImg} alt="Subject Image" className="img-fluid" />
                                                    </figure>
                                                    <div className="subject_ttl_detail">
                                                        <h5>{query1.data.layer ? query1.data.layer.title : ""}</h5>
                                                        <p><span>by</span> {query1.data.layer.author ? query1.data.layer.author.name : ""}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="progress_bar">
                                                <div className="progress_details d-flex align-items-center">
                                                    {getPercentage(query1.data.layer) !== 100 &&
                                                        <div className="progress">
                                                            <div className="progress-bar" style={{ width: `${getPercentage(query1.data.layer)}%` }}></div>
                                                        </div>
                                                    }
                                                    {getPercentage(query1.data.layer) === 100 &&
                                                        <div className="progress">
                                                            <div className="progress-bar completed" style={{ width: `${getPercentage(query1.data.layer)}%` }}></div>
                                                        </div>
                                                    }
                                                    <div className="completed_text">
                                                        <span>{`${getPercentage(query1.data.layer)}%`}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {/* <div className="search_icon">
                                        <img src={Icons.SearchIcon} alt="" className="img-fluid" />
                                    </div> */}

                                {/* { */}
                                {/* // hide div if percentage gets zero
                                    // getPercentage(query1.data.layer) !== 0 && */}

                                {/* } */}
                                {
                                    (topiclist != undefined && topiclist.length != 0) &&
                                    <div className="subjects_wrapper subject_topics_wrapper">
                                        <div className="subjects_header">
                                            <h6>Topics <span>({topiclist ? topiclist.length : 0})</span></h6>
                                            {/* <p>Learn by specific topics from subjects</p> */}
                                        </div>
                                        <div className="all_subjects_name_wrapper">
                                            <ul type="none" className="subjects_child d-flex flex-wrap">
                                                {

                                                    topiclist && topiclist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        d.subContents != null &&
                                                        <li>
                                                            {
                                                                <Link to={`/videolayer/videolayerContent/${d._id}`} state={id}>
                                                                    <div className="subject_main_list d-flex align-itmes-center">
                                                                        <div className="subject_img_wrap d-flex align-items-center">
                                                                            <figure className="subject_img">
                                                                                <img src={d.icon? d.icon:Images.defaultImg} alt="" className="img-fluid" />
                                                                            </figure>
                                                                            <div className="subject_details">
                                                                                <h6>{d.title}</h6>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            // hide div if percentage gets zero
                                                                            getPercentage(d) !== 0 && <div className="progressbar_wraper d-flex align-items-center">
                                                                                <div className="progress_details">
                                                                                    <span>{`${getPercentage(d)}%`}</span>
                                                                                    {getPercentage(d) !== 100 &&
                                                                                        <div className="progress">
                                                                                            <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                        </div>

                                                                                    }
                                                                                    {getPercentage(d) === 100 &&
                                                                                        <div className="progress">
                                                                                            <div className="progress-bar completed" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                                <div className="right_arrow">
                                                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </Link>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                {
                                                    topiclist && topiclist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        d.subContents === null &&
                                                        <li>
                                                            {
                                                                <Link to={`/videolayer/otherResource/${d._id}`} state={id}>
                                                                    <div className="subject_main_list d-flex align-itmes-center">
                                                                        <div className="subject_img_wrap d-flex align-items-center">
                                                                            <figure className="subject_img">
                                                                                <img src={d.icon?d.icon: Images.defaultImg} alt="" className="img-fluid" />
                                                                            </figure>
                                                                            <div className="subject_details">
                                                                                <h6>{d.title}</h6>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            // hide div if percentage gets zero
                                                                            getPercentage(d) !== 0 && <div className="progressbar_wraper d-flex align-items-center">
                                                                                <div className="progress_details">
                                                                                    <span>{`${getPercentage(d)}%`}</span>
                                                                                    {getPercentage(d) !== 100 &&
                                                                                        <div className="progress">
                                                                                            <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                        </div>

                                                                                    }
                                                                                    {getPercentage(d) === 100 &&
                                                                                        <div className="progress">
                                                                                            <div className="progress-bar completed" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                                <div className="right_arrow">
                                                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </Link>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                                {/* <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Embryology} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>General Embryology</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Brain} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Neuroanatomy</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Embryology} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Systemic Embryology</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Thorax} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Thorax</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Abdomen} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Abdomen, Pevis & Perineum</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Limb} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Upper Limb</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Microscope} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Histology</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Limb} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Lower Limb</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="subject_main_list d-flex align-itmes-center">
                                            <div className="subject_img_wrap d-flex align-items-center">
                                                <figure className="subject_img">
                                                    <img src={Icons.Osteology} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="subject_details">
                                                    <h6>Osteology</h6>
                                                </div>
                                            </div>
                                            <div className="progressbar_wraper d-flex align-items-center">
                                                <div className="progress_details">
                                                    <span>40%</span>
                                                    <div className="progress">
                                                        <div className="progress-bar" style={{width:"30%"}}></div>
                                                    </div>
                                                </div>
                                                <div className="right_arrow">
                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                }
                                {
                                    topiclist && topiclist.length == 0 &&
                                    <NoDataFound></NoDataFound>
                                }

                                {
                                    (
                                        ((contentslist != undefined && contentslist.length != 0) || (contentlist != undefined && contentlist.length != 0)) &&
                                        <div className="subjects_wrapper topics_concept_wrapper">
                                            <div className="subjects_header">
                                                <h6>Concept</h6>
                                                <p>Learn by specific topics from subjects</p>
                                            </div>
                                            <div className="all_subjects_name_wrapper">
                                                <div className="concepts_img" >
                                                    <Link to={`/videolayer/otherResource/${contentId}`}>
                                                        <img src={config && config?.subject_landing ? config?.subject_landing.concept?.image : ""}></img>
                                                    </Link>
                                                </div>
                                                {/* <div className="row align-items-center">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="how_to_use">
                                                        <ul type="none" className="use_child_list">
                                                            <li>How to use our content in study</li>
                                                            <li>Learn more from videos</li>
                                                            <li>Get prepared for the best!</li>
                                                        </ul>
                                                        <div className="learn_concept_btn">
                                                            <a href="/" className="btn_learn">Learn Concepts <img src={Icons.ArrowBlue} alt="Arrow" className="img-fluid" /></a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="concepts_img text-right">
                                                        <img src={Images.Concept} alt="" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div> */}
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    (
                                        (resourcelist != undefined && resourcelist.length != 0) &&
                                        <div className="other_reasource_wrapper">
                                            <div className="subjects_header">
                                                <h6> Resources</h6>
                                                <p>Explore more content to help you prepare</p>
                                            </div>
                                            <div className="resource_main">
                                                <div className="row">
                                                    {resourcelist && resourcelist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                                            <Link to={`/videolayer/otherResource/${d._id}`}>
                                                                <div className="resource_card d-flex">
                                                                    <div className="resource_img_detail">
                                                                        <figure className="res_img">
                                                                            <img src={d.icon?d.icon:Images.defaultImg} alt="" className="img-fluid" />
                                                                        </figure>
                                                                        <h6>{d.title}</h6>
                                                                        {/* <p>{d.}</p> */}
                                                                    </div>
                                                                    <div className="res_arrow">
                                                                        <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    ))}
                                                    {/* <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="resource_card d-flex">
                                            <div className="resource_img_detail">
                                                <figure className="res_img">
                                                    <img src={Images.Res2} alt="" className="img-fluid"/>
                                                </figure>
                                                <h6>How to Study in 1st Prof</h6>
                                                <p>Learn how to study in 1st Prof</p>
                                            </div>
                                            <div className="res_arrow">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="resource_card d-flex">
                                            <div className="resource_img_detail">
                                                <figure className="res_img">
                                                    <img src={Images.Res3} alt="" className="img-fluid"/>
                                                </figure>
                                                <h6>Grand Test Videos</h6>
                                                <p>Solution videos of all Grand Tests</p>
                                            </div>
                                            <div className="res_arrow">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="resource_card d-flex">
                                            <div className="resource_img_detail">
                                                <figure className="res_img">
                                                    <img src={Images.Res4} alt="" className="img-fluid"/>
                                                </figure>
                                                <h6>Recall Question Videos</h6>
                                                <p>Solution videos of all previous year tests</p>
                                            </div>
                                            <div className="res_arrow">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="resource_card d-flex">
                                            <div className="resource_img_detail">
                                                <figure className="res_img">
                                                    <img src={Images.Res5} alt="" className="img-fluid"/>
                                                </figure>
                                                <h6>DBMCI Live</h6>
                                                <p>Recordings of all DBMCI Live sessions</p>
                                            </div>
                                            <div className="res_arrow">
                                                <img src={Icons.VideoArrow} alt="" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {


                                    (topiclist == undefined || topiclist.length == 0) && (resourcelist == undefined || resourcelist.length == 0) && (contentslist == undefined || contentslist.length == 0) && (contentslist == undefined || contentslist.length == 0) &&
                                    <NoDataFound></NoDataFound>

                                }
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-12">
                            {/* <div className="videos_wrapper">
                        { video && (
                        <div className="recommended_video_wrapper">
                            <div className="subjects_header">
                                <h6>Recommended Video</h6>
                                <div className="view_all_text d-flex align-items-center">
                                    <div className="main_paragraph">
                                        <p>Start your learning journey</p>
                                    </div>
                                    <div className="view_text">
                                        <p><a href="/">View All</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="recommend_video_details">
                                <ul type="none" className="recommend_list">
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img">
                                                <img src={Images.VideoImg} alt="" className="img-fluid"/>
                                                <figcaption className="free_tag">
                                                    <span>Free</span>
                                                </figcaption>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <h6>Cranial Nerve Nuclei and Columns</h6>
                                                <span className="name_label">Dr.Ashwani Kumar</span>
                                                <div className="rate_timer">
                                                    <span>
                                                        <img src={Icons.Star} alt="Star" className="img-fluid"/> 5.0
                                                    </span>
                                                    <span>
                                                        <img src={Icons.Clock} alt="Clock" className="img-fluid"/> 01:10:54
                                                    </span>
                                                    <span className="play_icn">
                                                        <img src={Icons.Play} alt="Play" className="img-fluid"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img">
                                                <img src={Images.VideoImg} alt="" className="img-fluid"/>
                                                <figcaption className="free_tag">
                                                    <span>Free</span>
                                                </figcaption>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <h6>Cranial Nerve Nuclei and Columns</h6>
                                                <span className="name_label">Dr.Ashwani Kumar</span>
                                                <div className="rate_timer">
                                                    <span>
                                                        <img src={Icons.Star} alt="Star" className="img-fluid"/> 5.0
                                                    </span>
                                                    <span>
                                                        <img src={Icons.Clock} alt="Star" className="img-fluid"/> 01:10:54
                                                    </span>
                                                    <span className="play_icn">
                                                        <img src={Icons.Play} alt="Play" className="img-fluid"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img">
                                                <img src={Images.VideoImg} alt="" className="img-fluid"/>
                                                <figcaption className="free_tag">
                                                    <span>Free</span>
                                                </figcaption>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <h6>Cranial Nerve Nuclei and Columns</h6>
                                                <span className="name_label">Dr.Ashwani Kumar</span>
                                                <div className="rate_timer">
                                                    <span>
                                                        <img src={Icons.Star} alt="Star" className="img-fluid"/> 5.0
                                                    </span>
                                                    <span>
                                                        <img src={Icons.Clock} alt="Star" className="img-fluid"/> 01:10:54
                                                    </span>
                                                    <span className="play_icn">
                                                        <img src={Icons.Play} alt="Play" className="img-fluid"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>)}
                        
                        <div className="recommended_video_wrapper Free_videos_wrapper">
                            <div className="subjects_header">
                                <h6>Free Videos</h6>
                                <div className="view_all_text d-flex align-items-center">
                                    <div className="main_paragraph">
                                        <p>Start your learning journey with free videos</p>
                                    </div>
                                    <div className="view_text">
                                        <p><a href="/">View All</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="recommend_video_details">
                                <ul type="none" className="recommend_list">
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img">
                                                <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                                <figcaption className="free_tag">
                                                    <span>Free</span>
                                                </figcaption>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <h6>Cranial Nerve Nuclei and Columns</h6>
                                                <span className="name_label">Dr.Ashwani Kumar</span>
                                                <div className="rate_timer">
                                                    <span>
                                                        <img src={Icons.Star} alt="Star" className="img-fluid"/> 5.0
                                                    </span>
                                                    <span>
                                                        <img src={Icons.Clock} alt="Clock" className="img-fluid"/> 01:10:54
                                                    </span>
                                                    <span className="play_icn">
                                                        <img src={Icons.Play} alt="Play" className="img-fluid"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img">
                                                <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                                <figcaption className="free_tag">
                                                    <span>Free</span>
                                                </figcaption>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <h6>Cranial Nerve Nuclei and Columns</h6>
                                                <span className="name_label">Dr.Ashwani Kumar</span>
                                                <div className="rate_timer">
                                                    <span>
                                                        <img src={Icons.Star} alt="Star" className="img-fluid"/> 5.0
                                                    </span>
                                                    <span>
                                                        <img src={Icons.Clock} alt="Star" className="img-fluid"/> 01:10:54
                                                    </span>
                                                    <span className="play_icn">
                                                        <img src={Icons.Play} alt="Play" className="img-fluid"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recommend_list_main d-flex align-items-center">
                                            <figure className="user_img">
                                                <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                                <figcaption className="free_tag">
                                                    <span>Free</span>
                                                </figcaption>
                                            </figure>
                                            <div className="recommend_list_content">
                                                <h6>Cranial Nerve Nuclei and Columns</h6>
                                                <span className="name_label">Dr.Ashwani Kumar</span>
                                                <div className="rate_timer">
                                                    <span>
                                                        <img src={Icons.Star} alt="Star" className="img-fluid"/> 5.0
                                                    </span>
                                                    <span>
                                                        <img src={Icons.Clock} alt="Star" className="img-fluid"/> 01:10:54
                                                    </span>
                                                    <span className="play_icn">
                                                        <img src={Icons.Play} alt="Play" className="img-fluid"/>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div> */}
                            <div className="subjects_wrapper Subject_selection_right_side">
                                <div className="subjects_header">
                                    <h6>Move to other Subject</h6>
                                </div>
                                <div className="all_subjects_name_wrapper">
                                    <ul type="none" className="subjects_child d-flex flex-wrap">
                                        {videolist && videolist.slice().sort((a, b) => (a.position > b.position ? 1 : -1)).map((d, i) => (
                                            <li>
                                                <NavLink to={`/videolayer/${d._id}`}>
                                                    <div className="subject_main_list d-flex align-itmes-center">
                                                        <div className="subject_img_wrap d-flex align-items-center">
                                                            <figure className="subject_img">
                                                                <img src={d.icon?d.icon:Images.defaultImg} alt="" className="img-fluid" />
                                                            </figure>
                                                            <div className="subject_details">
                                                                <h6>{d.title}</h6>
                                                                <p>{d.author ? d.author.name : ''}</p>
                                                            </div>
                                                        </div>
                                                        {
                                                            getPercentage(d) !== 0 &&
                                                            <div className="progressbar_wraper d-flex align-items-center">
                                                                <div className="progress_details">
                                                                    <span>{`${getPercentage(d)}%`}</span>
                                                                    <div className="progress">
                                                                        <div className="progress-bar" style={{ width: `${getPercentage(d)}%` }}></div>
                                                                    </div>
                                                                </div>
                                                                <div className="right_arrow">
                                                                    <img src={Icons.VideoArrow} alt="" className="img-fluid" />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </NavLink>
                                            </li>
                                        ))}
                                        {/* <li>
												<div className="subject_main_list d-flex align-itmes-center">
													<div className="subject_img_wrap d-flex align-items-center">
														<figure className="subject_img">
															<img src={Icons.Micro} alt="" className="img-fluid" />
														</figure>
														<div className="subject_details">
															<h6>Microbiology</h6>
															<p>Dr.Ashwani Kumar</p>
														</div>
													</div>
													<div className="progressbar_wraper d-flex align-items-center">
														<div className="progress_details">
															<span>40%</span>
															<div className="progress">
																<div className="progress-bar" style={{ width: "30%" }}></div>
															</div>
														</div>
														<div className="right_arrow">
															<img src={Icons.VideoArrow} alt="" className="img-fluid" />
														</div>
													</div>
												</div>
											</li> */}
                                        {/* <li>
											<div className="subject_main_list d-flex align-itmes-center">
												<div className="subject_img_wrap d-flex align-items-center">
													<figure className="subject_img">
														<img src={Icons.Micro} alt="" className="img-fluid" />
													</figure>
													<div className="subject_details">
														<h6>Microbiology</h6>
														<p>Dr.Ashwani Kumar</p>
													</div>
												</div>
												<div className="progressbar_wraper d-flex align-items-center">
													<div className="progress_details">
														<span>40%</span>
														<div className="progress">
															<div className="progress-bar" style={{ width: "30%" }}></div>
														</div>
													</div>
													<div className="right_arrow">
														<img src={Icons.VideoArrow} alt="" className="img-fluid" />
													</div>
												</div>
											</div>
										</li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
export default VideoLayerTopic;
